import { render, staticRenderFns } from "./InvoicesNovaPoshtaTableMobile.vue?vue&type=template&id=be01411c&scoped=true"
import script from "./InvoicesNovaPoshtaTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesNovaPoshtaTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesNovaPoshtaTableMobile.vue?vue&type=style&index=0&id=be01411c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be01411c",
  null
  
)

export default component.exports